import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { API_URL } from '../../utils/data';
import { Circles } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import OtpStep from '../auth/OtpStep';
import ResetPasswordStep from '../auth/ResetPasswordStep';
import { sendOTP } from '../../features/auth/registerSlice';


const ProfileResetPassword = () => {
    const { t } = useTranslation();
    const [step, setStep] = useState(1);
    const [error, setError] = useState('');
    const { loading } = useSelector((state: RootState) => state.register);

      const dispatch = useDispatch<AppDispatch>();
    const {user} = useSelector((state: RootState) => state.user);

    const handleSendOTP = async () => {
        setError('');
        try {
            const phone = encodeURIComponent(String(user?.phone));
            const response = await fetch(`${API_URL}Authentication/sendOTP?isLogin=true&&phone=${phone}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            });

            if (!response.ok) {
                const errorData = await response.json();
                setError(errorData.message || 'فشل في إرسال الكود');
                return;
            }

            toast.success(t('otp-sent'));
            
            setStep(2);
        } catch (error: any) {
            console.error('Error sending OTP:', error);
            setError(`Error sending OTP: ${error.message}`);
        }
    };
        const handleResend = async () => {
            if (user?.phone) {
                dispatch(sendOTP(user?.phone)).unwrap();
                
            }
        };

    return (
        <div className=''>
            {step === 1 && (
                <div>
                    <h2 className='text-2xl font-semibold mb-3'>{t("reset-password")}</h2>
                    <p className='mb-2 text-gray-600'>{t("otp-will-be-sent-to")} {user?.phone}</p>

                    <div className='w-full bg-secondry rounded-lg py-3 mt-5 text-white cursor-pointer flex items-center justify-center'>
                        {loading ? (
                            <Circles height="20" width="20" color="#fff" ariaLabel="circles-loading" visible={true} />
                        ) : (
                            <button onClick={handleSendOTP} className='w-full cursor-pointer'>
                                {t("next")}
                            </button>
                        )}
                    </div>
                    {error && <p className='text-red-500 text-sm mt-2'>{error}</p>}
                </div>
            )}

            {step === 2 && (
                <OtpStep phone={String(user?.phone)} onVerified={() => setStep(3)} onResend={handleResend}/>
            )}

            {step === 3 && (
                <ResetPasswordStep phone={user?.phone as string} />
            )}
        </div>
    );
};

export default ProfileResetPassword;
